import RoleForm from "components/config/rolesMaster/RoleForm";
import PageHeader from "components/ui/PageHeader";
import { useToast } from "context/ToastContext";
import { API } from "middleware/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";

const RolesMaster = () => {
  const { showToast } = useToast();
  const [rolesList, setRolesList] = useState([]);

  const [selectedRole, setSelectedRole] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [editingRole, setEditingRole] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const [pageSize] = useState(10);

  const handleAddNew = () => {
    setEditingRole(null);
    setShowDialog(true);
  };

  const handleEdit = () => {
    setEditingRole(selectedRole);
    setShowDialog(true);
  };

  const handleRefresh = () => {
    setRefresh(!refresh);
  };

  const handleEditSubmit = async (newRole) => {
    try {
      if (editingRole) {
        const response = await API.editRole(selectedRole._id, newRole);

        if (response) {
          showToast({
            severity: "success",
            summary: "Success",
            detail: `${selectedRole.name} role edited successfully!`,
          });
          setShowDialog(false);
          setTimeout(() => {
            handleRefresh();
          }, 500);
        }
      } else {
        const response = await API.addRole(newRole);

        if (response) {
          showToast({
            severity: "success",
            summary: "Success",
            detail: `${newRole.name} role added successfully`,
          });
          setShowDialog(false);
          setTimeout(() => {
            handleRefresh();
          }, 500);
        }
      }
    } catch (error) {
      showToast({
        severity: "error",
        summary: "Error",
        detail: error.message,
      });
    }
  };

  useEffect(() => {
    const fetchAllRoles = async () => {
      try {
        const rolesData = await API.fetchAllRoles();
        setRolesList(rolesData);
      } catch (error) {
        setRolesList([]);
      }
    };

    fetchAllRoles();
  }, [refresh]);

  const rolesHeader = (rowData) => (
    <div className="flex gap-2">
      <Button
        size="small"
        icon="pi pi-plus"
        title="Add Ward"
        severity="primary"
        onClick={handleAddNew}
        outlined
        raised
      />
      <Button
        size="small"
        icon="pi pi-pencil"
        title="Edit Role"
        onClick={handleEdit}
        disabled={!selectedRole}
        tooltip={!selectedRole ? "Select a Role to Edit" : null}
        tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
        outlined
        raised
        severity="secondary"
      />
    </div>
  );

  return (
    <div className="flex gap-3 flex-column">
      <PageHeader text="Roles Master" />

      <DataTable
        size="small"
        value={rolesList}
        showGridlines
        paginator
        alwaysShowPaginator={false}
        rowHover
        header={rolesHeader}
        rows={pageSize}
        tableStyle={{ minWidth: "max-content" }}
        selection={selectedRole}
        onSelectionChange={(e) => setSelectedRole(e.value)}
        emptyMessage="No records available"
      >
        <Column selectionMode="single" headerStyle={{ width: "3rem" }}></Column>
        <Column field="name" header="Role Name" sortable />
        <Column
          field="privileges"
          header="Privileges"
          body={(rowData) => rowData.privileges?.join(", ")}
        />
      </DataTable>

      <Dialog
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        header={editingRole ? "Edit Role" : "Add Role"}
        style={{ width: "70vw" }}
        maximizable
      >
        <RoleForm
          initialValues={
            editingRole || {
              name: "",
              privileges: [],
            }
          }
          onSubmit={handleEditSubmit}
        />
      </Dialog>
    </div>
  );
};

export default RolesMaster;
